import { apiFetch } from "../api";
import { BASE_URL as u } from "../../commonUrls";

export const getDashboardSummary = async () => {
  const [statsRes, todayRes, notifRes, tasksRes, habitsRes] = await Promise.all([
    apiFetch(`${u}/planner/stats`),
    apiFetch(`${u}/planner/today?days=30`),
    apiFetch(`${u}/notification/unread-count`),
    apiFetch(`${u}/assigned-tasks/created`),
    apiFetch(`${u}/habits`),
  ]);

  const stats  = statsRes.ok  ? await statsRes.json()  : {};
  const today  = todayRes.ok  ? await todayRes.json()  : {};
  const unread = notifRes.ok  ? await notifRes.json()  : 0;
  const tasks  = tasksRes.ok  ? await tasksRes.json()  : [];
  const habits = habitsRes.ok ? await habitsRes.json() : [];

  return { stats, today, unread, tasks, habits };
};
